export default "__VITE_ASSET__CGXgkG$v__"